import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { NO_CACHE_TIME, serverStatusURL } from '../../../NonReact/constants/ApiConstants'
import { ServerStatusResponse } from '../../../NonReact/Types/ServerStatusTypes'

/**
 * Fetches the routed application server status rows.
 *
 * @returns Promise resolving to the server status response or undefined when empty.
 */
export const getServerStatus = (): Promise<Nullable<ServerStatusResponse>> =>
    requestGetJSON<ServerStatusResponse>(serverStatusURL, {
        errorOnNoContent: false,
        cacheTime: NO_CACHE_TIME
    })
